import { CultureInfo } from '../culture-info.model';
import { CultureInfoNd } from './nd';

/**
 * @ignore
 */
export const CultureInfoNdZW: CultureInfo = {
  name: 'nd-ZW',
  displayName: 'isiNdebele (Zimbabwe)',
  iso3LanguageCode: 'nde',
  iso2LanguageCode: 'nd',
  ietfLanguageTag: 'nd-ZW',
  parent: CultureInfoNd
};
